import { Component, OnInit, Input, SimpleChanges, OnChanges, EventEmitter, Output, Inject, OnDestroy, forwardRef } from '@angular/core';
import { FormGroup, FormControl, Validators} from '@angular/forms';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles 
} from './models/control';
import { GridHeaderModel, GridCellModel, GridRowModel, CellStyles, GridContainerStyle, HeaderStyles } from './models/grid'
import { FieldModel } from './models/field'
import { ToolModel } from './models/tool';
import { Styles, ControlContainerStyles } from './models/style';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { isEqual, isNil, set } from 'lodash-es';
import { GridComponent, ELoadingStatus } from './components/grid.component';
import { BaseComponent } from './components/base.component';
import { WorkBook, read as readExcelFile, writeFile as writeExcelFile, utils as excelUtils } from 'xlsx';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { FootprintManager_ShellService } from './FootprintManager.shell.service';
import { FootprintManager_OperationService } from './FootprintManager.operation.service';
import { FootprintManager_DatasourceService } from './FootprintManager.datasource.index';
import { FootprintManager_FlowService } from './FootprintManager.flow.index';
import { FootprintManager_ReportService } from './FootprintManager.report.index';
import { FootprintManager_LocalizationService } from './FootprintManager.localization.service';
import { FootprintManager_inventory_transfer_intermediaries_grid_ComponentContextService } from './FootprintManager.inventory_transfer_intermediaries_grid.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './FootprintManager.frontend.types'
import { $frontendTypes as $types} from './FootprintManager.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';
import { Inventory_owners_dd_singleComponent } from './Inventory.owners_dd_single.component'
import { Owners_projects_dd_singleComponent } from './Owners.projects_dd_single.component'
import { InventoryTransfers_accounts_dd_singleComponent } from './InventoryTransfers.accounts_dd_single.component'


interface IFootprintManager_inventory_transfer_intermediaries_gridComponentEntity {
  Id?: number, AccountId?: number, ProjectId?: number, Sequence?: number, Account?: { Id?: number, LookupCode?: string, Name?: string }, Project?: { Id?: number, LookupCode?: string, Name?: string, Owner?: { Id?: number, LookupCode?: string, Name?: string } }}

interface IFootprintManager_inventory_transfer_intermediaries_gridComponentInParams {
  inventoryTransferId: number, code: string, warehouseId: number, sourceProjectId: number, targetProjectId: number}


class FootprintManager_inventory_transfer_intermediaries_gridComponentRowModel extends GridRowModel {
  grid: FootprintManager_inventory_transfer_intermediaries_gridComponent;
  entity: IFootprintManager_inventory_transfer_intermediaries_gridComponentEntity;

  vars: { can_update?: boolean, can_delete?: boolean } = { };


 // temporarily put required on all edit controls
  override formGroup = new FormGroup({
    Owner_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    Project_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    Account_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
  });

  override cells = {
    Sequence: null,
    Owner: null,
    Project: null,
    Account: null,
  }

  get $fields_Owner_selector_inParams_statusId(): number {
    if (!this.entity) return null; 
    const $row = this;
    const $utils = this.$utils;
    const $grid = this.grid;
    const expr = 1;
    
    return expr;
  }
  get $fields_Owner_selector_inParams_projectId(): number {
    if (!this.entity) return null; 
    const $row = this;
    const $utils = this.$utils;
    const $grid = this.grid;
    const expr = $row.cells.Project.editControl.value;
    
    return expr;
  }
  get $fields_Project_selector_inParams_statusId(): number {
    if (!this.entity) return null; 
    const $row = this;
    const $utils = this.$utils;
    const $grid = this.grid;
    const expr = 1;
    
    return expr;
  }
  get $fields_Project_selector_inParams_ownerId(): number {
    if (!this.entity) return null; 
    const $row = this;
    const $utils = this.$utils;
    const $grid = this.grid;
    const expr = $row.cells.Owner.editControl.value;
    
    return expr;
  }
  cacheValueFor_$fields_Project_selector_inParams_excludedProjectIds: number[];
  get $fields_Project_selector_inParams_excludedProjectIds(): number[] {
    if (!this.entity) return null; 
    const $row = this;
    const $utils = this.$utils;
    const $grid = this.grid;
    const expr = $utils.isDefined($row.cells.Project.editControl.value) ? [$row.cells.Project.editControl.value] : null;
    
    if(!isEqual(this.cacheValueFor_$fields_Project_selector_inParams_excludedProjectIds, expr)) {
      this.cacheValueFor_$fields_Project_selector_inParams_excludedProjectIds = expr;
    }
    return this.cacheValueFor_$fields_Project_selector_inParams_excludedProjectIds;
  }


  constructor(
    grid: FootprintManager_inventory_transfer_intermediaries_gridComponent,
    private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: FootprintManager_ShellService,
private $datasources: FootprintManager_DatasourceService,
private $flows: FootprintManager_FlowService,
private $reports: FootprintManager_ReportService,
private $localization: FootprintManager_LocalizationService,
private $operations: FootprintManager_OperationService,
private $logger: CleanupLoggerService,
private $context: FootprintManager_inventory_transfer_intermediaries_grid_ComponentContextService,
) {
    super();

    this.grid = grid;

    this.cells.Sequence = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Sequence,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Owner = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Owner,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['Owner_edit'] as DatexFormControl, 
        ESelectBoxType.dropdown, null,
        false,
        false,
        '', null)
      );
    
    this.cells.Project = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Project,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['Project_edit'] as DatexFormControl, 
        ESelectBoxType.dropdown, null,
        false,
        false,
        '', null)
      );
    
    this.cells.Account = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Account,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['Account_edit'] as DatexFormControl, 
        ESelectBoxType.dropdown, null,
        false,
        false,
        '', null)
      );
    
    
    this.formGroup
      .controls['Owner_edit']
      .valueChanges
      .pipe(
        takeUntil(this.$unsubscribe$)
      )
      .subscribe(() => {
        this.on_owner_changed();
      });
    this.formGroup
      .controls['Project_edit']
      .valueChanges
      .pipe(
        takeUntil(this.$unsubscribe$)
      )
      .subscribe(() => {
        this.on_project_changed();
      });
  }

  async $initializeExisting(entity: IFootprintManager_inventory_transfer_intermediaries_gridComponentEntity) {
    this.entity = entity;

    this.rowId = [this.entity.Id].join('-');

    await this.$dataLoaded();
  }

  async $initializeNew(entity?: IFootprintManager_inventory_transfer_intermediaries_gridComponentEntity) {
    this.isNew = true;

    if (entity) {
      this.entity = entity;
    }
    else {
      this.entity = {};
    }

    this.rowId = [this.entity.Id].join('-');
    await this.$dataLoaded();
    // mark the whole form as dirty, since this is a new row 
    // and even if it is valid, it should have a changed state
    this.formGroup.markAsDirty();
  }

  private $unsubscribe$ = new Subject();
  override destroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  $init() {
  }

  async $dataLoad() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    const $resultKey = this.entity.Id;
    const inParams = {
      $keys:[$resultKey],
      inventoryTransferId:  $grid.inParams.inventoryTransferId ,
    };
    const data = await this.$datasources.InventoryTransfers.ds_inventory_transfer_intermediaries_grid.getByKeys(inParams);
    
    await this.grid.$applyLinkedDatasourcesAndCustomColumns(inParams, data);
      
    this.entity = data.result[0] as IFootprintManager_inventory_transfer_intermediaries_gridComponentEntity;
    await this.$dataLoaded();
  }

  async $dataLoaded() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    (this.cells.Sequence.displayControl as TextModel).text = $row.entity.Sequence?.toString();
    (this.cells.Owner.displayControl as TextModel).text = $row.entity?.Project?.Owner?.LookupCode;
    (this.cells.Owner.editControl as SelectBoxModel).reset($row.entity?.Project?.Owner?.Id);
    (this.cells.Project.displayControl as TextModel).text = $row.entity?.Project?.LookupCode;
    (this.cells.Project.editControl as SelectBoxModel).reset($row.entity?.ProjectId);
    (this.cells.Account.displayControl as TextModel).text = $row.entity?.Account?.LookupCode;
    (this.cells.Account.editControl as SelectBoxModel).reset($row.entity?.AccountId);

  }

  override async refresh() {
    if (this.grid.$hasMissingRequiredInParams) {
      return Promise.resolve(null);
    }
    await this.$dataLoad();
    // grid refresh skipSelf=true, skipParent=false, skipChildren=false  
    this.grid.$refreshEvent.emit();
  }

  override async save() {
    if (this.isNew) {
      await this.on_save_new_intermediary();
      this.isNew = false;
    } else {
      await this.on_update_intermediary();
    } 
  }

  override $cellClicked(cellId: string) {
    super.$cellClicked(cellId);
    switch(cellId) {
    }
  }

  //#region private flows
  on_save_new_intermediary(event = null) {
    return this.on_save_new_intermediaryInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_save_new_intermediaryInternal(
    $row: FootprintManager_inventory_transfer_intermediaries_gridComponentRowModel,
  $grid: FootprintManager_inventory_transfer_intermediaries_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_inventory_transfer_intermediaries_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  try{
      //Call function create_inventory_transfer_intermediary.   
      const inventory_transfer_intermediary_inParams = {
          inventory_transfer_id: $grid.inParams.inventoryTransferId,
          sequence: $grid.rows.length, 
          project_id: $row.cells.Project?.editControl.value,
          account_id: $row.cells.Account?.editControl.value
      }                            
  
      const inventoryTransferIntermediaryCreationResult = await $flows.InventoryTransfers.create_inventory_transfer_intermediary(inventory_transfer_intermediary_inParams);
      if(inventoryTransferIntermediaryCreationResult.is_success)
      {
          $row.entity.Id = inventoryTransferIntermediaryCreationResult.id;    
          $row.refresh();
      }
      else
      {
          await DisplayErrorMsg("Error creating an inventory transfer intermediary.");
          throw new Error(inventoryTransferIntermediaryCreationResult.error);        
      }
  }
  catch (error) {
      await DisplayErrorMsg("Error creating an inventory transfer intermediary.");
      throw new Error(error.message);
  }
  
  async function DisplayErrorMsg(error_msg: string)
  {  
      $shell.FootprintManager.openErrorDialog('Error inventory transfer intermediary: ', error_msg);    
  }
  }
  on_owner_changed(event = null) {
    return this.on_owner_changedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_owner_changedInternal(
    $row: FootprintManager_inventory_transfer_intermediaries_gridComponentRowModel,
  $grid: FootprintManager_inventory_transfer_intermediaries_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_inventory_transfer_intermediaries_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  $row.cells.Project.editControl.value = null;
  }
  on_project_changed(event = null) {
    return this.on_project_changedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_project_changedInternal(
    $row: FootprintManager_inventory_transfer_intermediaries_gridComponentRowModel,
  $grid: FootprintManager_inventory_transfer_intermediaries_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_inventory_transfer_intermediaries_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  if (!$utils.isDefined($row.cells.Owner.editControl.value) && $utils.isDefined($row.cells.Project.editControl.value))  {
      let project = (await $datasources.Owners.ds_get_project_by_projectId.getList({ $top: 1, projectId: $row.cells.Project.editControl.value})).result[0];
  
      $row.cells.Owner.editControl.value = project.OwnerId;
  }
  }
  on_update_intermediary(event = null) {
    return this.on_update_intermediaryInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_update_intermediaryInternal(
    $row: FootprintManager_inventory_transfer_intermediaries_gridComponentRowModel,
  $grid: FootprintManager_inventory_transfer_intermediaries_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_inventory_transfer_intermediaries_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  try{
      //Call function update_inventory_transfer_intermediary.   
      const update_intermediary_inParams = {
          intermediary_id: $row.entity.Id,
          project_id: $row.cells.Project?.editControl.value,
          account_id: $row.cells.Account?.editControl.value
      }                            
  
      const intermediaryUpdateResult = await $flows.InventoryTransfers.update_inventory_transfer_intermediary(update_intermediary_inParams);
      if(intermediaryUpdateResult.is_success)
          $row.refresh();
      else
      {
          await DisplayErrorMsg("Error updating the inventory transfer intermediary.");
          throw new Error(intermediaryUpdateResult.error);        
      }
  }
  catch (error) {
      await DisplayErrorMsg("Error updating the inventory transfer intermediary.");
      throw new Error(error.message);
  }
  
  async function DisplayErrorMsg(error_msg: string)
  {  
      $shell.FootprintManager.openErrorDialog('Error inventory transfer intermediary: ', error_msg);    
  }
  }
  //#endregion private flows

}


@Component({
  standalone: true,
  imports: [
    SharedModule,
    forwardRef(() => Inventory_owners_dd_singleComponent),
    forwardRef(() => Owners_projects_dd_singleComponent),
    forwardRef(() => InventoryTransfers_accounts_dd_singleComponent),
  ],
  selector: 'FootprintManager-inventory_transfer_intermediaries_grid',
  templateUrl: './FootprintManager.inventory_transfer_intermediaries_grid.component.html'
})
export class FootprintManager_inventory_transfer_intermediaries_gridComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();
  //#endregion Outputs

  entities: IFootprintManager_inventory_transfer_intermediaries_gridComponentEntity[];

  pageSize = 10;
  pageSkip = 0;
  totalCount = 0;
  loadingStatus = ELoadingStatus.Loading;

canEdit: boolean = true;
// to stop add from flow
// canAdd = false; //hide add button, check on exitFromLastCell 
// bottomToolbar.addLine.hidden = true; //hide add button, no check on exitFromLastCell 
// bottomToolbar.addLine.control.readOnly = true; //disable add button, check on exitFromLastCell 
canAdd: boolean = true; 
  
  containerStyles: GridContainerStyle = new GridContainerStyle('cellsWidth', ['default','fit-content-table']);


  inParams: IFootprintManager_inventory_transfer_intermediaries_gridComponentInParams = { inventoryTransferId: null, code: null, warehouseId: null, sourceProjectId: null, targetProjectId: null };


  //#region Variables
  //#endregion
  //#region Events
  
  //#endregion

  headers = {
     Sequence: new GridHeaderModel(new HeaderStyles(null, null), 'Sequence', 'Sequence', false, false, null, false),       Owner: new GridHeaderModel(new HeaderStyles(null, null), 'Owner', 'Owner', false, false, null, false),       Project: new GridHeaderModel(new HeaderStyles(null, null), 'Project', 'Project', false, false, null, false),       Account: new GridHeaderModel(new HeaderStyles(null, null), 'Account', 'Account', false, false, null, false),  
  };

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  rows: FootprintManager_inventory_transfer_intermediaries_gridComponentRowModel[] = [];

  @Input('inventoryTransferId') set $inParams_inventoryTransferId(value: any) {
    this.inParams['inventoryTransferId'] = value;
  }
  get $inParams_inventoryTransferId(): any {
    return this.inParams['inventoryTransferId'] ;
  }
  @Input('code') set $inParams_code(value: any) {
    this.inParams['code'] = value;
  }
  get $inParams_code(): any {
    return this.inParams['code'] ;
  }
  @Input('warehouseId') set $inParams_warehouseId(value: any) {
    this.inParams['warehouseId'] = value;
  }
  get $inParams_warehouseId(): any {
    return this.inParams['warehouseId'] ;
  }
  @Input('sourceProjectId') set $inParams_sourceProjectId(value: any) {
    this.inParams['sourceProjectId'] = value;
  }
  get $inParams_sourceProjectId(): any {
    return this.inParams['sourceProjectId'] ;
  }
  @Input('targetProjectId') set $inParams_targetProjectId(value: any) {
    this.inParams['targetProjectId'] = value;
  }
  get $inParams_targetProjectId(): any {
    return this.inParams['targetProjectId'] ;
  }

  topToolbar = {
      delete_intermediary: new ToolModel(new ButtonModel('delete_intermediary', new ButtonStyles(['destructive'], null), false, false, false, 'Delete', 'icon-ic_fluent_delete_20_regular', null)
    , false)
  };

  bottomToolbar = {
    addLine : new ToolModel(new ButtonModel(null, null, false, false, false, 'Add row', 'icon-ic_fluent_add_circle_20_regular')),
  };




  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: FootprintManager_ShellService,
    private $datasources: FootprintManager_DatasourceService,
    private $flows: FootprintManager_FlowService,
    private $reports: FootprintManager_ReportService,
    private $localization: FootprintManager_LocalizationService,
    private $operations: FootprintManager_OperationService,
    private $logger: CleanupLoggerService,
    private $context: FootprintManager_inventory_transfer_intermediaries_grid_ComponentContextService,
    ) {
    super();
    this.title = 'inventory transfer intermediaries';
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$checkRequiredInParams();
    if (!this.$hasMissingRequiredInParams) {
      this.$init();
    } else {
      this.$initEmpty();
    }
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$checkRequiredInParams();
      if(!this.$hasMissingRequiredInParams) {
        this.$init();
      } else {
        this.$initEmpty();
      }
    }
  }

  $missingRequiredInParams = [];
  get $hasMissingRequiredInParams(): boolean {
    return !!this.$missingRequiredInParams.length;
  }
  
  $checkRequiredInParams() {
    this.$missingRequiredInParams = [];
      if(isNil(this.inParams.inventoryTransferId)) {
        this.$missingRequiredInParams.push('inventoryTransferId');
      }
      if(isNil(this.inParams.code)) {
        this.$missingRequiredInParams.push('code');
      }
      if(isNil(this.inParams.warehouseId)) {
        this.$missingRequiredInParams.push('warehouseId');
      }
      if(isNil(this.inParams.sourceProjectId)) {
        this.$missingRequiredInParams.push('sourceProjectId');
      }
      if(isNil(this.inParams.targetProjectId)) {
        this.$missingRequiredInParams.push('targetProjectId');
      }
  }

  initialized = false;

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();

    this.clearRows();
  }

  async $init() {
    const $grid = this;
    const $utils = this.$utils;

    this.pageSize = 50;


    this.initialized = true;

    this.pageSkip = 0;
    this.refresh(true, true, null);
  }

  protected override $initEmpty() {
    this.clearRows();
  }

  private $subscribeFormControlValueChanges() {

  }

  reload() {
    this.pageSkip = 0;
    this.refresh();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    if (this.$hasMissingRequiredInParams) {
      return Promise.resolve(null);
    }
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();

    // children
    if (skipChildren === false) {
    }

    return result;
  }

  async $dataLoad() {
    this.loadingStatus = ELoadingStatus.Loading;
    const $grid = this;
    const $utils = this.$utils;
    const inParams = {
      $top: this.pageSize,
      $skip: this.pageSkip,
      inventoryTransferId:  $grid.inParams.inventoryTransferId ,
    };
    try {
      const data = await this.$datasources.InventoryTransfers.ds_inventory_transfer_intermediaries_grid.getList(inParams);
      
      await this.$applyLinkedDatasourcesAndCustomColumns(inParams, data);

      this.entities = data.result as IFootprintManager_inventory_transfer_intermediaries_gridComponentEntity[];
      this.totalCount = data.totalCount;

      await this.$dataLoaded();
      if (this.totalCount === 0) {
        this.loadingStatus = ELoadingStatus.NoResults;
      } else {
        this.loadingStatus = ELoadingStatus.Loaded;
      }
    } catch(error) {
      console.error("Error loading data:", error);
      this.loadingStatus = ELoadingStatus.Error;
    }
  }

  async $dataLoaded() {
    const $grid = this;
    const $utils = this.$utils;
    
    this.clearRows();

    if(this.entities) {
      let rowLoadPromises = [];
      for (let entity of this.entities) {
        const row = new FootprintManager_inventory_transfer_intermediaries_gridComponentRowModel(
          this,
          this.$utils,
          this.$settings,
          this.$shell, 
          this.$datasources,
          this.$flows,
          this.$reports,
          this.$localization,
          this.$operations,
          this.$logger,
          this.$context);
        rowLoadPromises.push(row.$initializeExisting(entity));
        this.rows.push(row);
      }
      await Promise.all(rowLoadPromises);
    }

    await this.on_data_loaded();
  }

  
    async $applyLinkedDatasourcesAndCustomColumns(inParams: any, outParams: any) {
      const $datasource = { inParams: inParams };
      const $utils = this.$utils;
  
    }

  clearRows() {
    if(this.rows && this.rows.length) {
      this.rows.forEach(r => r.destroy());
    }
    this.rows = [];
  }

  selectedRows: FootprintManager_inventory_transfer_intermediaries_gridComponentRowModel[] = [];
  hasSelectedRows() {
    return this.selectedRows.length > 0;
  }

  async $selectionChanged(selectedRows: any[]) {
    this.selectedRows = selectedRows;
  }

  async addRow(entity?: IFootprintManager_inventory_transfer_intermediaries_gridComponentEntity) {
    const row = new FootprintManager_inventory_transfer_intermediaries_gridComponentRowModel(
      this,
      this.$utils,
      this.$settings,
      this.$shell, 
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$localization,
      this.$operations,
      this.$logger,
      this.$context);
    await row.$initializeNew(entity);
    this.rows.push(row);
    row.setEditMode();
    return row;
  }
  
  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_delete_intermediary(event = null) {
    return this.on_delete_intermediaryInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_delete_intermediaryInternal(
    $grid: FootprintManager_inventory_transfer_intermediaries_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_inventory_transfer_intermediaries_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  if ($grid.selectedRows.length === 0) {
      $shell.FootprintManager.openErrorDialog('Inventory transfer intermediary','No record selected.');
      return;
  } 
  else {
      //Call the function delete_inventory_transfer_intermediary for the selected rows.   
      let isSelectedRowsDeletedSuccessfully: boolean = true;         
      for (let i = 0; i < $grid.selectedRows.length; i++){
  
          const intermediary_id_inParam = {
              id: $grid.selectedRows[i].entity.Id
          }  
  
          const intermediaryDeleteResult = await $flows.InventoryTransfers.delete_inventory_transfer_intermediary(intermediary_id_inParam);
          if(!intermediaryDeleteResult.is_success)
          {
              isSelectedRowsDeletedSuccessfully = false;
              await DisplayErrorMsg('Error deleting the inventory transfer intermediary with sequence # ' + $grid.selectedRows[i].entity.Sequence);
              throw new Error(intermediaryDeleteResult.error);            
          }
      }
  
      if(isSelectedRowsDeletedSuccessfully)
      {
          //Call the function update_inventory_transfer_intermediary to update the squence for all grid's records.   
          //let isSequenceUpdatedSuccessfully: boolean = true;         
          
          let updated_intermediaries_ids = (await $datasources.InventoryTransfers.ds_inventory_transfer_intermediaries_grid.get({ inventoryTransferId: $grid.inParams.inventoryTransferId })).result.map(({ Id }) => Id);        
          if($utils.isDefined(updated_intermediaries_ids) && updated_intermediaries_ids.length > 0)
          {
              const intermediaries_ids_inParams = {
                  intermediaries_ids: updated_intermediaries_ids
              }
              
              const intermediariesSequenceUpdateResult = await $flows.InventoryTransfers.update_inventory_transfer_intermediaries_sequence(intermediaries_ids_inParams);
              if(!intermediariesSequenceUpdateResult.is_success)
              {
                  //isSequenceUpdatedSuccessfully = false;
                  await DisplayErrorMsg('The selected record(s) has/have been deleted successfully, however the intermediaries sequence have not updated.');
                  throw new Error(intermediariesSequenceUpdateResult.error);            
              }
          }         
          
          /*if(isSequenceUpdatedSuccessfully)
          {
              await $shell.FootprintManager.openInfoDialog('Inventory transfer intermediary', 'Successfully deleting the selected inventory transfer intermediaries.');
          }*/
      }
  
      $grid.refresh();
  }
  
  async function DisplayErrorMsg(error_msg: string)
  {  
      $shell.FootprintManager.openErrorDialog('Error inventory transfer intermediary: ', error_msg);    
  }
  
  }
  on_data_loaded(event = null) {
    return this.on_data_loadedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_data_loadedInternal(
    $grid: FootprintManager_inventory_transfer_intermediaries_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_inventory_transfer_intermediaries_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  // Don't allow line modifications if missing inputs
  if (!$utils.isDefined($grid.inParams.code) || !$utils.isDefined($grid.inParams.sourceProjectId) || !$utils.isDefined($grid.inParams.targetProjectId) || !$utils.isDefined($grid.inParams.warehouseId)) {
      $grid.canAdd = false;
      $grid.canEdit = false;
      $grid.topToolbar.delete_intermediary.control.readOnly = true;    
  }
  else
  {
      let inventory_transfer_status = (await $datasources.InventoryTransfers.ds_inventory_transfer_status.get({ inventoryTransferId: $grid.inParams.inventoryTransferId })).result[0].Status;
      if($utils.isDefined(inventory_transfer_status.EnumName) && (inventory_transfer_status.EnumName == 'Created' || inventory_transfer_status.EnumName == 'FailedToStart'))
      {
          $grid.canAdd = true;
          $grid.canEdit = true;
          $grid.topToolbar.delete_intermediary.control.readOnly = false;    
      }
      else
      {
          $grid.canAdd = false;
          $grid.canEdit = false;
          $grid.topToolbar.delete_intermediary.control.readOnly = true;            
      }
  }
  }
  //#endregion private flows


 
  close() {
    this.$finish.emit();
  }
}
